class ScrollBehavior extends HTMLElement {
  scrollToBlock(id) {
    const el = document.querySelector(id)
    if (el) {
      el.scrollIntoView({behavior: "smooth"})
    }
  }
}

// Use base DynamicSectionElement class to enable replacing of content loaded from Section Rendering API
customElements.define('scroll-behavior', ScrollBehavior)
